import { useMutation } from 'react-query'
import { type BankDataDomain } from '../../../../types/domain/expert-domain'
import { type InternationalBankDataPersistence } from '../../../../types/persistence/international-person-persistence'
import { api } from '../../../api'

const updateExpertInternationaBanklData = async (
  id: number,
  data: InternationalBankDataPersistence
): Promise<BankDataDomain> => {
  const response = await api.put<BankDataDomain>(`/experts/${id}/international-payment-data`, data)
  return response.data
}

export const useExpertInternationalBankDataMutation = () => {
  return useMutation({
    mutationFn ({ id, data }: { id: number, data: InternationalBankDataPersistence }) {
      return updateExpertInternationaBanklData(id, data)
    },
  })
}
